import { render } from "./CollectionPreview.vue?vue&type=template&id=d304f46a"
import script from "./CollectionPreview.vue?vue&type=script&lang=js"
export * from "./CollectionPreview.vue?vue&type=script&lang=js"

import "./CollectionPreview.vue?vue&type=style&index=0&id=d304f46a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__